import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "selected_area",
  "use": "selected_area-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"selected_area\"><path d=\"M3.5 5.85H2v2.1h1.5zm0-2.35h.25V2H2v1.75h1.5zM7.949 2h-2.1v1.5h2.1zM2 16h6.75V9.25H2zm1.5-5.25h3.75v3.75H3.5zM14.25 2v1.5h.25v.25H16V2zm.25 5.95H16v-2.1h-1.5zm0 4.2H16v-2.1h-1.5zM10.051 16h2.1v-1.5h-2.1zm4.449-1.5h-.25V16H16v-1.75h-1.5zM12.149 2h-2.1v1.5h2.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol